import { Box, Button, Typography } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../ui/colors";

interface Prop {
  children: React.ReactNode;
  isLocked?: boolean;
  message?: string;
}

export const LockedCard = ({ children, isLocked, message }: Prop) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: "relative", minHeight: "100%", maxHeight: "100%" }}>
      {isLocked && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            borderRadius: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.52) 100%)",
            backdropFilter: "blur(2px) saturate(120%)",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 420,
              bgcolor: "rgba(var(--fx-surface-basergb, 255, 255, 255), 0.96)",
              borderRadius: "24px",
              px: { xs: 3, sm: 4 },
              py: 3.5,
              textAlign: "center",
              border: "1px solid rgba(234, 236, 240, 0.9)",
              boxShadow:
                "0 18px 45px rgba(16, 24, 40, 0.12), 0 2px 8px rgba(16, 24, 40, 0.04)",
            }}
          >
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 2,
                bgcolor: colors.orange[50],
                boxShadow: `0 0 0 8px ${colors.orange[50]}55`,
              }}
            >
              <Lock sx={{ color: colors.orange.base, fontSize: 21 }} />
            </Box>

            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1rem",
                color: "var(--fx-surface-text, #0F172A)",
                letterSpacing: "-0.01em",
              }}
            >
              {message || "Premium Feature"}
            </Typography>

            <Typography
              sx={{
                maxWidth: 310,
                mx: "auto",
                mt: 1,
                fontSize: "0.78rem",
                color: "var(--fx-surface-textsecondary, #64748B)",
                fontWeight: 500,
                lineHeight: 1.55,
              }}
            >
              Unlock this feature and get the full Flownect experience with your upgraded plan.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate("/business/apps-center")}
              fullWidth
              sx={{
                mt: 2.5,
                height: 42,
                bgcolor: colors.orange.base,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 800,
                fontSize: "0.9rem",
                boxShadow: "0 8px 16px rgba(226, 135, 67, 0.22)",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: colors.orange[600],
                  boxShadow: "0 10px 20px rgba(226, 135, 67, 0.28)",
                  transform: "translateY(-1px)",
                },
                "&:active": {
                  transform: "translateY(0)",
                },
              }}
            >
              Upgrade Now
            </Button>
          </Box>
        </Box>
      )}

      <Box
        sx={{
          filter: isLocked ? "blur(1.5px) grayscale(0.15)" : "none",
          opacity: isLocked ? 0.72 : 1,
          pointerEvents: isLocked ? "none" : "auto",
          transition: "filter 0.25s ease, opacity 0.25s ease",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};